












import {
  defineComponent, reactive, toRefs, watch,
} from '@vue/composition-api'

import { wait } from '@/lib/utils/wait'

export default defineComponent({
  components: {
    //
  },
  props: {
    /** Start the timer when this condition is true */
    startTimerWhen: { type: Boolean, required: true },
    /** The milliseconds to wait before rendering what's inside the slot */
    wait: { type: Number, default: 6000 },
  },

  setup(props) {
    const state = reactive({
      show: false,
      cancelShow: false,
      currentTimerToken: 0,
    })

    // watch for changes in starttimer
    watch(() => props.startTimerWhen, async (start) => {
      state.currentTimerToken += 1
      if (start) {
        // if start timer true, get the current token...
        const myToken = state.currentTimerToken
        // ...start the countdown for show to take effect
        await wait(props.wait)
        if (
          // ...check if the token still is the current
          // otherwise the count down is obsolete and
          // should not have any effect.
          myToken === state.currentTimerToken
          && props.startTimerWhen
        ) state.show = true
        return
      }
      state.show = false
    })

    return { ...toRefs(state) }
  },
})

